  <!-- ============================================================== -->
  <!-- Preloader - style you can find in spinners.css -->
  <div class="preloader">
    <div class="lds-ripple">
      <div class="lds-pos"></div>
      <div class="lds-pos"></div>
    </div>
  </div>
  <!-- ============================================================== -->
  <div class="page-breadcrumb">
    <div class="row d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">Subject Management
        </h3>
        <div class="d-flex align-items-center">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb m-0 p-0">
              <li class="breadcrumb-item"><a></a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="align-self-center">
        <a *ngIf="!isLoading" (click)="update_all_value($event)"
          class="ml-2 text-white d-sm-inline btn btn-sm btn-primary shadow-sm"><i class="fa fa-upload"
            aria-hidden="true"></i>
          Update values </a>
        <a *ngIf="isLoading" disbled=true class="ml-2 text-white d-sm-inline btn btn-sm btn-primary shadow-sm"><i
            class="fas fa-sync    "></i>
          Updating... </a>
        <a data-toggle="modal" data-target="#create-rubrics-modal"
          class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
            class="fa fa-plus fa-sm text-white-50"></i>
          Rubrics </a>
        <a data-toggle="modal" data-target="#create-attainment-type-modal"
          class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
            class="fa fa-plus fa-sm text-white-50"></i>
          Add Field Type </a>
        <a data-toggle="modal" data-target="#create-attainment-modal"
          class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
            class="fa fa-plus fa-sm text-white-50"></i>
          Add Attainment Field </a>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <table class="table table-hover table-striped" *ngIf="Attainment">
        <thead>
          <tr>
            <th>Student \ Particulars</th>
            <th *ngFor="let factor of Attainment['fields']">{{factor.attainment_field_name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let student of Students">
            <th>{{student.register_number}} - {{student.username}}</th>
            <th *ngFor="let field of Attainment['fields']">
              <span *ngFor="let value of Attainment['values']"> <input
                  *ngIf="field.attainment_field_id == value.field_id && student.student_id == value.student_id"
                  (input)="update_value(value)" [(ngModel)]=value.field_value>
              </span>
            </th>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>No. of Students Attended:</th>
            <th *ngFor="let field of Attainment['fields']">
              {{field.attainment_field_presents}}
            </th>
          </tr>
          <tr>
            <th>Threshold:</th>
            <th *ngFor="let field of Attainment['fields']">
              <input (input)="update_threshold(field)" [(ngModel)]=field.attainment_field_threshold>
            </th>
          </tr>
          <tr>
            <th>No. of Students above Threshold:</th>
            <th *ngFor="let field of Attainment['fields']">
              {{field.attainment_above_threshold}}
            </th>
          </tr>
          <tr>
            <th>Attainment Level:</th>
            <th *ngFor="let field of Attainment['fields']">
              {{field.attainment_field_level}}
            </th>
          </tr>
          <tr>
            <th>Tool weightage:</th>
            <th *ngFor="let field of Attainment['fields']">
              <input (input)="update_threshold(field)" [(ngModel)]=field.attainment_field_weightage>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="page-breadcrumb">
      <div class="row d-flex justify-content-between">
        <div class="align-self-center ">
          <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">{{Attainment.attainment_name}} :
            {{Attainment.attainment_value}}
          </h3>
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb m-0 p-0">
                <!-- <li class="breadcrumb-item"><a></a>
                </li> -->
              </ol>
            </nav>
          </div>
        </div>
        <div class="align-self-center">


        </div>
      </div>
    </div>
  </div>

  <!-- AttainmentField Modal modal content -->
  <div id="create-attainment-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <form #formValues4="ngForm" (ngSubmit)="create_factor(formValues4)" class="pl-3 pr-3">

            <!-- Attainment Type - attainment_type - text - required -->
            <div class="form-group" *ngIf="FieldTypes[0].field_type_id == AttainmentField.attainment_field_type">
              <input [hidden]=true class="form-control" [(ngModel)]="AttainmentField.attainment_type"
                name="attainment_type" #attainment_type="ngModel" type="text" placeholder="Enter Attainment Type"
                required>
            </div>
            <div class="form-group" *ngIf="FieldTypes[0].field_type_id != AttainmentField.attainment_field_type">
              <input [hidden]=true class="form-control" [(ngModel)]="AttainmentField.attainment_type"
                name="attainment_type" #attainment_type="ngModel" type="text" placeholder="Enter Attainment Type"
                required>
            </div>
            <!-- End of Attainment Type -->

            <!-- Field Type - form - [ field_type_name - field_type_id ] - ng-select - selectedIndustry -->
            <div class="form-group">
              <label>Field Type</label>
              <ng-select [items]="FieldTypes" bindLabel="field_type_name" autofocus bindValue="field_type_id"
                [(ngModel)]="AttainmentField.attainment_field_type" name="attainment_field_type" placeholder="Select
                Field Type">
              </ng-select>
            </div>
            <!-- End of Select Field Type -->

            <!-- Exam - form - [ exam_name - exam_id ] - ng-select - selectedIndustry -->
            <div class="form-group" *ngIf="FieldTypes[0].field_type_id == AttainmentField.attainment_field_type">
              <label>Exam</label>
              <ng-select [items]="Exams" bindLabel="exam_name" autofocus bindValue="exam_id"
                [(ngModel)]="AttainmentField.exam" name="exam" placeholder="Select
                Exam">
              </ng-select>
            </div>
            <!-- End of Select Exam -->

            <!-- Field name - attainment_field_name - text - required -->
            <div class="form-group">
              <label>Field name</label>
              <input class="form-control" [(ngModel)]="AttainmentField.attainment_field_name"
                name="attainment_field_name" #attainment_field_name="ngModel" type="text" placeholder="Enter Field name"
                required>
              <div class="error" *ngIf="attainment_field_name.touched && !attainment_field_name.valid"> Field name is
                required</div>
            </div>
            <!-- End of Field name -->

            <!-- Field description - attainment_field_description - text - required -->
            <div class="form-group">
              <label>Field description</label>
              <input class="form-control" [(ngModel)]="AttainmentField.attainment_field_description"
                name="attainment_field_description" #attainment_field_description="ngModel" type="text"
                placeholder="Enter Field description" required>
              <div class="error" *ngIf="attainment_field_description.touched && !attainment_field_description.valid">
                AttainmentField
                name is
                required</div>
            </div>
            <!-- End of Field description -->

            <!-- Course Outcome - form - [ course_o_name - course_o_id ] - ng-select - selectedIndustry -->
            <div class="form-group" *ngIf="FieldTypes[0].field_type_id != AttainmentField.attainment_field_type">
              <label>Course Outcome</label>
              <ng-select [items]="COutcomes[0]['attainments']" bindLabel="course_o_name" autofocus
                bindValue="course_o_id" [(ngModel)]="AttainmentField.customer" name="course_o"
                placeholder="Select Course Outcome">
              </ng-select>
            </div>
            <!-- End of Select Course Outcome -->

            <div class="form-group text-center">
              <button class="btn btn-primary" type="submit">Add Attainment Field</button>
            </div>


          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Coutcome Modal -->


  <!-- Rubrics modal content -->
  <div id="create-rubrics-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">

          <div class="container">
            <div class="row">
              <table class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>DESCRIPTION</th>
                </thead>
                <tbody>

                  <tr>
                    <th>1 - (LOW)</th>
                    <th>50% of student above Threshold</th>
                  </tr>
                  <tr>
                    <th>2 - (MEDIUM)</th>
                    <th>60% of student above Threshold</th>
                  </tr>
                  <tr>
                    <th>3 - (HIGH)</th>
                    <th>70% of student above Threshold</th>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
  <!-- End of Rubrics -->


  <!-- FieldType Modal modal content -->
  <div id="create-attainment-type-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <form #formValues5="ngForm" (ngSubmit)="create_field_type(formValues5)" class="pl-3 pr-3">

            <!-- FieldType name - field_type_name - text - required -->
            <div class="form-group">
              <label>Field Type name</label>
              <input class="form-control" [(ngModel)]="FieldType.field_type_name" name="field_type_name"
                #field_type_name="ngModel" type="text" placeholder="Enter FieldType name" required>
              <div class="error" *ngIf="field_type_name.touched && !field_type_name.valid"> FieldType name is
                required</div>
            </div>
            <!-- End of FieldType name -->


            <div class="form-group text-center">
              <button class="btn btn-primary" type="submit">Add FieldType</button>
            </div>


          </form>
          <mat-accordion>
            <mat-expansion-panel hideToggle *ngFor="let factor of FieldTypes">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{factor.field_type_name}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <button class="btn btn-light">Delete Field Type</button>
            </mat-expansion-panel>
          </mat-accordion>

        </div>
      </div>
    </div>
  </div>
  <!-- End of FieldType Modal -->
